import { STEP_WRITE } from 'common-app/api/query/step-write';
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { setStep } from './data';
export default [
    {
        request: {
            query: STEP_WRITE,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: (variables) => {
            let step = variables === null || variables === void 0 ? void 0 : variables.step;
            setStep(step);
            return {
                data: {
                    write_step: step,
                },
            };
        },
    },
];
